export function isVisibleForKeyboardUser(el) {
  if (el === document) {
    return true;
  }

  const $style = document.defaultView.getComputedStyle(el, null);

  if (!el) {
    return false;
  } else if (!$style) {
    return false;
  } else if ($style.display === "none") {
    return false;
  } else if ($style.visibility === "hidden") {
    return false;
  } else if (
    ($style.display === "block" || $style.display === "inline-block") &&
    $style.height === "0px" &&
    $style.overflow === "hidden"
  ) {
    return false;
  } else {
    return (
      $style.position === "fixed" ||
      isVisibleForKeyboardUser(
        el.parentNode instanceof ShadowRoot ? el.parentNode.host : el.parentNode
      )
    );
  }
}

const checkIfFocusable = (element) => {
  // TODO shorter version of this?
  return (
    (element.tagName &&
      (element.tagName.toLowerCase() === "button" ||
        element.tagName.toLowerCase() === "input" ||
        element.tagName.toLowerCase() === "select" ||
        element.tagName.toLowerCase() === "textarea" ||
        (element.tabindex && element.tabindex !== -1)) &&
      element.disabled === false) ||
    (element.getAttribute && element.getAttribute("href"))
  );
};

const findFocusables = (element) => {
  const focusables = [];

  const iterate = (currentElement) => {
    if (
      currentElement &&
      currentElement.tagName &&
      currentElement.tagName.toLowerCase() === "slot"
    ) {
      const nodes = currentElement.assignedElements();
      if (nodes && nodes.length) {
        nodes.forEach((node) => {
          if (checkIfFocusable(node)) {
            focusables.push(node);
          } else if (node.shadowRoot) {
            iterate(node);
          } else if (node.querySelectorAll) {
            iterate(node);
          }
        });
      }
    } else {
      const currentLevel = currentElement.shadowRoot
        ? currentElement.shadowRoot.querySelectorAll("*")
        : currentElement.querySelectorAll
        ? currentElement.querySelectorAll("*")
        : [];
      currentLevel.forEach((currentLevelEl) => {
        if (
          currentLevelEl.shadowRoot ||
          (currentLevelEl.tagName &&
            currentLevelEl.tagName.toLowerCase() === "slot")
        ) {
          iterate(currentLevelEl);
        } else if (checkIfFocusable(currentLevelEl)) {
          focusables.push(currentLevelEl);
        }
      });
    }
  };
  iterate(element);

  return focusables;
};

export function getVisibleFocusables(host: HTMLElement): HTMLElement[] {
  // version without shadow DOM
  // const allFocusable = host.querySelectorAll(
  //   'button:enabled, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]):not(:disabled)'
  // );
  // enhancement for shadow DOM
  const allFocusable = findFocusables(host);

  const visibleFocusableElements = [];

  for (const element of allFocusable) {
    if (isVisibleForKeyboardUser(element)) {
      visibleFocusableElements.push(element);
    }
  }
  return visibleFocusableElements;
}

export const getCurrentActiveElement = (activeElement) => {
  return activeElement.shadowRoot
    ? getCurrentActiveElement(activeElement.shadowRoot.activeElement)
    : activeElement;
};

const checkIfArrayContainsElement = (array, element) => {
  let contains = false;
  array.map((arrayEl) => {
    if (arrayEl === element) {
      contains = true;
    }
  });
  return contains;
};

const findElementAndParents = (element) => {
  const parents = [];
  parents.push(element);
  const addParent = (el) => {
    if (el && !el.host) {
      parents.push(el);
      addParent(el.parentNode);
    } else if (el && el.host) {
      addParent(el.host);
    }
  };
  addParent(element.parentNode);
  return parents;
};

export function startWatchingFocusOutAndClick(
  host,
  focusController,
  closeElement,
  withoutTrigger = true,
  eventType = "click"
) {
  function watchClick(e) {
    if (
      !(
        (e.originalTarget &&
          checkIfArrayContainsElement(
            findElementAndParents(e.originalTarget),
            host
          )) ||
        (e.composedPath() &&
          checkIfArrayContainsElement(e.composedPath(), host))
      )
    ) {
      closeElement();
      focusController.abort();
    }
  }

  function watchKeyDown(e) {
    if (e.key === "Escape" || e.key === "Esc") {
      closeElement();
      focusController.abort();
    } else if (e.which === 9 || e.keyCode === 9) {
      const visibleFocusableElements = getVisibleFocusables(host);
      const firstFocusable = visibleFocusableElements[0];
      const firstFocusableInsideElement = visibleFocusableElements[1];
      const lastFocusable =
        visibleFocusableElements[visibleFocusableElements.length - 1];
      // enhancement for shadow DOM, without shadow dom it would simply be document.activeElement
      const activeElement = getCurrentActiveElement(document.activeElement);
      if (
        (e.shiftKey &&
          (activeElement === firstFocusable ||
            (!withoutTrigger &&
              activeElement === firstFocusableInsideElement))) ||
        (!e.shiftKey && activeElement === lastFocusable) ||
        (e.shiftKey && !visibleFocusableElements.includes(activeElement))
      ) {
        closeElement();
        focusController.abort();
      }
    }
  }

  document.body.addEventListener(eventType, watchClick, {
    signal: focusController.signal,
  } as AddEventListenerOptions);
  document.body.addEventListener("keydown", watchKeyDown, {
    signal: focusController.signal,
  } as AddEventListenerOptions);
}

export function trapFocus(host, focusController) {
  function watchKeyDown(e) {
    if (e.which === 9 || e.keyCode === 9) {
      const visibleFocusableElements = getVisibleFocusables(host);
      const firstFocusableInsideElement = visibleFocusableElements[0];
      const lastFocusable =
        visibleFocusableElements[visibleFocusableElements.length - 1];
      // enhancement for shadow DOM, without shadow dom it would simply be document.activeElement
      const activeElement = getCurrentActiveElement(document.activeElement);
      if (e.shiftKey && activeElement === firstFocusableInsideElement) {
        e.preventDefault();
        lastFocusable.focus();
      } else if (!e.shiftKey && activeElement === lastFocusable) {
        e.preventDefault();
        firstFocusableInsideElement.focus();
      }
    }
  }

  document.body.addEventListener("keydown", watchKeyDown, {
    signal: focusController.signal,
  } as AddEventListenerOptions);
}

export function handleEscKey(focusController, closeElement) {
  function watchKeyDown(e) {
    if (e.key === "Escape" || e.key === "Esc") {
      closeElement();
      focusController.abort();
    }
  }

  document.body.addEventListener("keydown", watchKeyDown, {
    signal: focusController.signal,
  } as AddEventListenerOptions);
}
